import OrganizationRepository from "../domain/data/OrganizationRepository";
import Organization from "../domain/entities/Organization";
import { RoleLevel } from "../domain/entities/Role";
import User from "../domain/entities/User";
import { organizations, demoRootOrg } from "./InitData";
import { v4 as uuidv4 } from "uuid";

export default class MockOrganizationRepository
  implements OrganizationRepository
{
  private static organizations: Organization[] = organizations;
  private static demoRootOrg: Organization = demoRootOrg;

  async getOrganizations(user: User): Promise<Organization[]> {
    if (user.role.level === RoleLevel.PaisleyAdministrator) {
      return organizations;
    } else if (user.role.level === RoleLevel.Administrator) {
      /*const filteredOrg = organizations.filter(
        (org) => org.id === user.organization.id
      );
      return filteredOrg;*/
      return user.organization.childOrganizations || [];
    }
    return organizations;
  }

  async deleteOrganization(orgId: string): Promise<Boolean> {
    const record = MockOrganizationRepository.organizations.find(
      (record) => record.id === orgId
    );
    if (record) {
      MockOrganizationRepository.organizations =
        MockOrganizationRepository.organizations.filter(
          (record) => record.id !== orgId
        );
      return true;
    }
    return false;
  }

  async getOrganization(orgId: string): Promise<Organization> {
    const organization = MockOrganizationRepository.organizations.find(
      (record) => record.id === orgId
    );
    if (!organization) {
      throw new Error("Organization not found");
    }
    return organization;
  }

  async getOrganizationByURl(org: string): Promise<Organization> {
    return demoRootOrg;
  }

  async saveOrganizations(
    objOrganization: Organization
  ): Promise<Organization> {
    if (!objOrganization.id) {
      objOrganization.id = uuidv4();
      MockOrganizationRepository.organizations.push(objOrganization);
      return objOrganization;
    } else {
      const record = MockOrganizationRepository.organizations.find(
        (record) => record.id === objOrganization.id
      );
      if (record) {
        record.name = objOrganization.name;
        record.description = objOrganization.description;
        record.url = objOrganization.url;
        record.status = objOrganization.status;
      }
      return record as Organization;
    }
  }
}
